module.exports = function (svg) {
  $(svg).find('[display]').each(function () {
    this.getAttribute('display') === 'none' && $(this).remove();
  });

  return svg;
};
